import type React from 'react';

import { Button } from '@xing-com/button';
import type {
  ContentError,
  ArticlesError,
} from '@xing-com/crate-common-graphql-types';
import { IconHide } from '@xing-com/icons';

import { useDisableArticleMutation } from '../../../../hooks/use-disable-article-mutation';
import type { ArticleCardView } from '../../../../types/types';

type Props = {
  article: ArticleCardView;
  onCompleted?: (article: ArticleCardView) => void;
  onError?: (error: ContentError | ArticlesError | Error) => void;
};

export const HideArticleButton: React.FC<Props> = ({
  article,
  onCompleted,
  onError,
}) => {
  const { handleDisableArticle, loading } = useDisableArticleMutation({
    onCompleted,
    onError,
  });

  const handleClick = () => {
    handleDisableArticle({ article });
  };

  return (
    <Button
      icon={IconHide}
      size="small"
      variant="tertiary"
      loading={loading}
      onClick={handleClick}
    />
  );
};
